var _rect, _rect2, _rect3, _rect4, _polygon, _rect5, _circle, _rect6, _polygon2, _polygon3, _polygon4, _polygon5, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path8, _path9, _rect16, _path10, _rect17, _rect18, _rect19, _path11, _path12, _path13, _path14, _circle3, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _rect20, _rect21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssetManager(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bfc717e4-0ce1-40c2-86b9-35a542da0074",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 998.28223,
    height: 697.55116,
    viewBox: "0 0 998.28223 697.55116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_manager") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 149.66797,
    y: 24,
    width: 103,
    height: 120,
    fill: "#f2f2f2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 427.66797,
    y: 94,
    width: 103,
    height: 120,
    fill: "#f2f2f2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 706.66797,
    y: 24,
    width: 103,
    height: 120,
    fill: "#f2f2f2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 228.62109,
    y: 430.33668,
    width: 270.98999,
    height: 67.57001,
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "784.198 696.3 545.438 696.3 612.488 580.17 664.818 489.53 784.198 696.3",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 136.93799,
    y: 515.84998,
    width: 396.83997,
    height: 180.5,
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 664.40025,
    cy: 442.31496,
    r: 47.05512,
    fill: "#6c63ff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1.56445,
    y: 695.55116,
    width: 860.78955,
    height: 2,
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "499.608 434.87 499.608 497.91 435.798 497.91 474.798 430.34 496.998 430.34 499.608 434.87",
    opacity: 0.1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "533.778 515.85 533.778 696.35 321.228 696.35 321.428 696 425.438 515.85 533.778 515.85",
    opacity: 0.1
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "679.538 696.3 545.438 696.3 612.488 580.17 615.488 585.36 679.538 696.3",
    opacity: 0.1
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "664.628 696.45 335.168 696.45 335.428 696 443.478 508.85 499.898 411.12 600.488 585.36 664.538 696.3 664.628 696.45",
    fill: "#6c63ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.40025,
    cy: 393.31496,
    r: 20.26772,
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M544.29639,500.99005A368.02149,368.02149,0,0,1,423.57422,480.7254C371.522,462.72833,328.87939,437.9046,296.832,406.94366c-60.62109-58.56592-110.32129-67.39209-141.33349-64.48584-33.57032,3.14746-53.11084,20.33789-53.3042,20.51123l-1.33545-1.48877c.19726-.17725,20.14062-17.75781,54.32324-21.00146,20.04541-1.90088,41.00781,1.41113,62.30664,9.84716,26.56055,10.52,53.72314,29.085,80.73291,55.1792,31.83643,30.75733,74.231,55.4292,126.00586,73.32959,95.04736,32.86133,202.16943,24.90528,293.89892-21.8291,30.3711-15.47461,60.38868-26.03711,89.21778-31.394,36.35351-6.75684,70.83008-5.18848,102.47949,4.6582,69.54883,21.63721,117.05371,20.48975,144.6582,15.71924,29.78418-5.148,43.29786-15.45068,43.43067-15.5542l1.22851,1.57861c-.55957.43506-14.0459,10.71387-44.31933,15.94629-27.82227,4.80957-75.667,5.97461-145.5918-15.78076-70.80078-22.02441-142.50879,2.312-190.19531,26.60792A383.87946,383.87946,0,0,1,573.398,499.87188Q558.79492,500.98956,544.29639,500.99005Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M318.50781,424.57257l-1.43115-1.397a73.10676,73.10676,0,0,0,14.66211-25.65088c4.86572-14.64306,7.24268-37.769-9.06787-64.7832-16.688-27.63965-17.439-50.08935-15.13086-64.05517,2.51221-15.19629,8.9209-23.71436,9.19238-24.06934l1.58936,1.21436c-.064.08349-6.417,8.55615-8.82764,23.29931-2.22559,13.61133-1.44922,35.51709,14.88867,62.57666,16.72754,27.70508,14.24951,51.47315,9.22559,66.5332C328.16455,414.55792,318.8999,424.1712,318.50781,424.57257Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M393.52686,246.22442h-144v-144h144Zm-142-2h140v-140h-140Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M597.5083,495.57208l-1.43164-1.39649a73.122,73.122,0,0,0,14.66211-25.65039c4.86621-14.64355,7.24219-37.76953-9.06836-64.78369-16.6875-27.63965-17.43848-50.08935-15.12988-64.05517,2.51172-15.19629,8.91992-23.71436,9.19238-24.06934l1.58887,1.21436c-.06348.08349-6.417,8.55615-8.82813,23.29931-2.22558,13.61133-1.44922,35.51709,14.88965,62.57666,16.72754,27.70508,14.249,51.47315,9.22461,66.53369C607.16455,485.55841,597.8999,495.17071,597.5083,495.57208Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M672.52686,317.22442h-144v-144h144Zm-142-2h140v-140h-140Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M875.5083,423.57257l-1.43164-1.397a73.11541,73.11541,0,0,0,14.66211-25.65088c4.86621-14.64306,7.24219-37.769-9.06836-64.7832-16.6875-27.63965-17.43848-50.08935-15.12988-64.05517,2.51172-15.19629,8.91992-23.71436,9.19238-24.06934l1.58887,1.21436c-.06348.08349-6.417,8.55615-8.82813,23.29931-2.22558,13.61133-1.44922,35.51709,14.88965,62.57666,16.72754,27.70508,14.249,51.47315,9.22461,66.5332C885.16455,413.55792,875.8999,423.1712,875.5083,423.57257Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M950.52686,245.22442h-144v-144h144Zm-142-2h140v-140h-140Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 178.66797,
    y: 43,
    width: 88,
    height: 2,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 178.66797,
    y: 65,
    width: 88,
    height: 2,
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 178.66797,
    y: 87,
    width: 88,
    height: 2,
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 455.66797,
    y: 111,
    width: 88,
    height: 2,
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 455.66797,
    y: 133,
    width: 88,
    height: 2,
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 455.66797,
    y: 155,
    width: 88,
    height: 2,
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 733.66797,
    y: 43,
    width: 88,
    height: 2,
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 733.66797,
    y: 65,
    width: 88,
    height: 2,
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 733.66797,
    y: 87,
    width: 88,
    height: 2,
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M922.279,765.37659c5.391,19.92827,23.85626,32.27034,23.85626,32.27034s9.7248-19.968,4.33383-39.89629-23.85626-32.27033-23.85626-32.27033S916.88805,745.44833,922.279,765.37659Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#6c63ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M930.20067,761.0938c14.7929,14.40029,16.59974,36.53688,16.59974,36.53688s-22.17718-1.21088-36.97008-15.61117-16.59974-36.53689-16.59974-36.53689S915.40777,746.6935,930.20067,761.0938Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#3f3d56"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 191.66797,
    y: 558,
    width: 103,
    height: 120,
    fill: "#f2f2f2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M435.52686,779.22442h-144v-144h144Zm-142-2h140v-140h-140Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#fff"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 218.66797,
    y: 577,
    width: 88,
    height: 2,
    fill: "#6c63ff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 218.66797,
    y: 599,
    width: 88,
    height: 2,
    fill: "#6c63ff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 218.66797,
    y: 621,
    width: 88,
    height: 2,
    fill: "#6c63ff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M327.39722,318.41089h-.00006c-24.032,0-43.51376,21.62049-43.51376,48.29071v33.8848h10.42141l6.0334-12.55459-1.50836,12.55459h66.98482l5.48492-11.41327-1.37121,11.41327h7.54176V373.98076C377.47014,343.2904,355.05173,318.41089,327.39722,318.41089Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M277.53809,539.79617,250.821,551.15093,157.97913,626.6267a27.32591,27.32591,0,0,0-6.01134,14.6944c-.66793,8.683-28.72087,54.1021-18.702,60.11344s46.087,24.04538,48.09075,12.02269,12.69062-63.45308,12.69062-63.45308l89.50224-80.15126Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M172.67353,703.43832l-11.35476,33.39636s12.02269,12.69062,6.01134,23.37745v36.736h-9.351l-2.67171-19.36989s-10.65081,19.12517-16.03025,19.36989c-11.27717.513-33.60924,4.52434-34.27717-1.487s16.91107-11.87155,16.91107-11.87155l18.702-51.43039,8.01512-31.39258Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M347.00252,531.11312s6.01134,58.77759-11.35476,69.46442S241.47,645.32866,241.47,645.32866s32.72843,30.72465,26.04916,38.07185-36.736,27.385-40.74356,23.37745-48.75868-52.09832-43.41526-67.46064,79.48333-65.45686,79.48333-65.45686l8.683-31.39258,2.67171-25.38123,28.05294-18.034Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.54264,
    cy: 265.19486,
    r: 27.84476,
    fill: "#ffb9b9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M337.9855,377.82384s-1.33585,25.38123,19.36989,33.39635S305.925,471.33364,305.925,471.33364V413.224s9.351-10.01891,0-25.38124Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#ffb9b9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M382.40266,497.04883,377.05924,523.098,361.029,612.60023s13.35854,38.07185-4.67549,37.40392-9.351-41.41148-9.351-41.41148l9.351-74.13992V505.73189Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#ffb9b9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M267.51919,484.35822l-6.01135,23.37745-27.385,66.12479s-18.702,31.39257-3.33964,30.72464,15.36233-30.72464,15.36233-30.72464l31.39257-53.43418V490.36956Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#ffb9b9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M262.8437,679.393l22.04159,20.70574s15.36233-3.33964,21.37367,14.6944,10.01891,29.38879,10.01891,29.38879l-8.01513,4.67549-10.0189-14.02647s-6.01135,25.38123-12.02269,27.385-36.06807,15.36233-33.39636,0l14.6944-21.37367s2.00378-24.04537-4.00757-26.04915S241.47,692.75149,241.47,692.75149Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M348.06136,551.81886s-62.78515-22.70952-66.79272-20.70574a30.12046,30.12046,0,0,1-9.40793,2.44178l.057-9.121s20.70574-7.3472,32.06051-2.67171,46.087,25.38123,46.087,25.38123Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M309.93256,457.97509s18.034-20.70574,23.37745-33.39635a32.79069,32.79069,0,0,1,17.3353-17.04617s40.10644,9.031,39.43851,25.06129-25.38123,40.74356-25.38123,40.74356,3.33963,88.83431-14.6944,87.49846a38.68242,38.68242,0,0,1-8.01513-16.03026c-2.00378-9.351-64.121-19.36988-64.121-19.36988s-5.34342,9.351-6.01135,5.34341,5.34342-102.19285,5.34342-102.19285l31.85141-21.05373Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#d0cde1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M384.93877,426.14142l.44725.251a9.215,9.215,0,0,1,4.7053,8.03735l-.00685,49.56884a9.28769,9.28769,0,0,0,3.3039,7.0688c2.57292,2.18849,4.95882,5.34208.03509,6.98332-8.01513,2.67171-39.40771,16.03026-40.07563,11.35477s-2.00379-10.01891,0-10.01891c1.5687,0,10.91537-47.89585,18.42554-68.37431A9.21645,9.21645,0,0,1,384.93877,426.14142Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#d0cde1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M286.22115,426.24855l-9.351,2.67171-10.68684,46.087s-12.69061,2.67171-8.68305,7.3472S278.206,499.05261,278.206,499.05261Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#d0cde1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M339.76739,331.71338a22.82089,22.82089,0,0,0-18.00636-9.18879h-.8543c-16.47157,0-29.82435,14.90488-29.82435,33.291v.00007h5.51919l.89134-6.78453,1.30687,6.78453h32.734l2.74249-5.73984-.68564,5.73984h6.43972q4.50748,22.38537-12.95306,44.77074h10.9699l5.48491-11.47968-1.37121,11.47968h20.9113l4.11371-26.40333C367.18589,354.40943,355.69682,337.64177,339.76739,331.71338Z",
    transform: "translate(-100.85889 -101.22442)",
    fill: "#2f2e41"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 311.14111,
    y: 430.33668,
    width: 104,
    height: 33.90002,
    opacity: 0.1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 317.14111,
    y: 401.2367,
    width: 94,
    height: 58,
    fill: "#6c63ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetManager);
export default __webpack_public_path__ + "static/media/AssetManager.d77e2f5a.svg";
export { ForwardRef as ReactComponent };